/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { bank } from '../models/bank';
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { vw_bank } from '../models/vw_bank';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BankService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postBankDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bank/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of banks
     * @returns vw_bank A list of bank
     * @throws ApiError
     */
    public getBanks(): CancelablePromise<Array<vw_bank>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/banks',
        });
    }

    /**
     * Get bank by id
     * @returns vw_bank The bank data
     * @throws ApiError
     */
    public getBank({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_bank> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bank/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Bank not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a bank by id
     * @returns any Bank deleted successfully
     * @throws ApiError
     */
    public deleteBank({
        id,
    }: {
        /**
         * The bank id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/bank/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Bank not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Bank
     * @returns any Bank created successfully
     * @throws ApiError
     */
    public postBank({
        requestBody,
    }: {
        requestBody: bank,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/bank',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Bank
     * @returns any Bank updated successfully
     * @throws ApiError
     */
    public putBank({
        requestBody,
    }: {
        requestBody: bank,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/bank',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Bank not found`,
                500: `Internal server error`,
            },
        });
    }

}
